import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { Card } from '../../common/Card'
import { statisticsQueries } from '../../../api/statistics'
import { ISocietiesModel } from '../../../interfaces/models/societies.interfaces'

interface StatisticsSectionProps {
  society: ISocietiesModel
}

export const StatisticsSection = ({
  society,
}: StatisticsSectionProps): JSX.Element => {
  const { translate } = useAppTranslation()

  const { data: statistics } = useQuery(
    statisticsQueries.getSocietyStatistics(society._id)
  )

  const cards = [
    ...(statistics?.totalUsers
      ? [
          {
            title: translate(
              'societyStatisticsExportsView.statistics.numberLogins'
            ),
            text: statistics.totalUsers,
          },
        ]
      : []),
    ...(statistics?.posts
      ? [
          {
            title: translate(
              'societyStatisticsExportsView.statistics.numberPosts'
            ),
            text: statistics.posts,
          },
        ]
      : []),
    ...(statistics?.postLikes
      ? [
          {
            title: translate(
              'societyStatisticsExportsView.statistics.numberLikes'
            ),
            text: statistics.postLikes,
          },
        ]
      : []),
    ...(statistics?.postComments
      ? [
          {
            title: translate(
              'societyStatisticsExportsView.statistics.numberComments'
            ),
            text: statistics.postComments,
          },
        ]
      : []),
  ]

  return (
    <div>
      <p className="my-4" style={theme.textVariants.lead}>
        {translate('societyStatisticsExportsView.statistics.headerTitle')}
      </p>
      <div className="grid grid-cols-1 gap-4 md:max-w-5xl md:grid-cols-2">
        {cards.map((_card) => {
          return (
            <Card key={_card.title} className="w-full max-w-none">
              {{
                body: (
                  <div className="flex flex-1 flex-col p-4 text-left">
                    <p style={theme.textVariants.h2}>{_card.text}</p>
                    <p
                      style={theme.textVariants.base}
                      className="mt-1 text-neutral-40"
                    >
                      {_card.title}
                    </p>
                  </div>
                ),
              }}
            </Card>
          )
        })}
      </div>
    </div>
  )
}
